import { createTheme } from '@mui/material/styles';



// Function to generate the theme dynamically
export const getTheme = () => {
  // Fetch value from localStorage (assuming 'subdomain' is stored there)
  const subdomain = localStorage.getItem('host') || 'default';

  // Define default palette values
  let primaryColor = '#a739d3ff';
  let backgroundColor = '#a739d3ff';
  let switchColor = '#a739d3ff';
  let primaryBackground = '#ffffff';
  let secondaryBackground = '#a739d3ff';
  

  // Define and return the theme object
  return createTheme({
    palette: {
      primary: {
        main: primaryColor,  // Dynamically set primary color
      },
      background: {
        default: backgroundColor,  // Dynamically set background color
      },
      switchColor: {
        main: switchColor,  // Dynamically set switch color
      },
      appbar: {
        default: '#ffffff',
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: primaryBackground,
          },
          secondary: {
            backgroundColor: secondaryBackground, // Ensure the body has the same background colour
          },
        },
      },
      MuiStepIcon: {
        styleOverrides: {
          root: {
            '&.Mui-active': {
              color: switchColor,
            },
            '&.Mui-completed': {
              color: switchColor,
            },
          },
        },
      },
    },
  });
};
